import type { AdminResponse } from "../../lib/api";
import { durationShort, isoZ } from "../../lib/format";

export function ResponseCard({
  response,
  onClick,
}: {
  response: AdminResponse;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex flex-col items-start gap-3 rounded-card border border-border bg-bg-elevated p-5 text-left transition hover:border-accent"
    >
      <div className="flex w-full items-center justify-between">
        <span className="font-mono text-sm font-medium text-fg group-hover:text-accent">
          {response.participant}
        </span>
        <span className="text-xs text-fg-muted">{durationShort(response.durationMs)}</span>
      </div>
      <div className="text-xs text-fg-muted">{isoZ(response.submittedAt)}</div>
      <div className="flex flex-wrap gap-2 text-[11px]">
        {response.operatingSystem ? (
          <span className="rounded-full bg-border/50 px-2 py-0.5">
            {response.operatingSystem}
          </span>
        ) : null}
        {response.aiExperience ? (
          <span className="rounded-full bg-border/50 px-2 py-0.5">
            {response.aiExperience}
          </span>
        ) : null}
      </div>
    </button>
  );
}
